import { createContext, useMemo, useReducer } from "react";

import type { Dispatch, ReactNode } from "react";

// TODO: Use SWR to manage user server state instead of context
interface RoleProviderProps {
  children: ReactNode;
}

interface RoleContextState {
  company: Company | null;
  role: Role | null;
  isLoading: boolean;
}

interface SetRoleAction {
  role: Role;
  type: "setRole";
}

interface ClearRole {
  type: "clearRole";
}

interface SetLoadedAction {
  type: "setLoaded";
}

type RoleActions = SetRoleAction | ClearRole | SetLoadedAction;

interface RoleContextDispatch {
  dispatch: Dispatch<RoleActions>;
}

const initialState: RoleContextState = {
  company: null,
  role: null,
  isLoading: true,
};

export const roleContext = createContext<
  RoleContextState & RoleContextDispatch
>({
  ...initialState,
  dispatch: () => null,
});

function reducer(
  state: RoleContextState,
  action: RoleActions,
): RoleContextState {
  switch (action.type) {
    case "setRole":
      return {
        role: action.role,
        company: action.role.company ?? null,
        isLoading: false,
      };
    case "clearRole":
      return { company: null, role: null, isLoading: false };
    case "setLoaded":
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export function RoleProvider(props: RoleProviderProps) {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const memoState = useMemo(() => ({ ...state, dispatch }), [state]);

  return (
    <roleContext.Provider value={memoState}>{children}</roleContext.Provider>
  );
}
